export let navigationPaneScreenReaderOnlyText = "ycvULe";
export default {navigationPaneScreenReaderOnlyText};